import { render, staticRenderFns } from "./HelpListContainer.vue?vue&type=template&id=bc1a070c&scoped=true"
import script from "./HelpListContainer.vue?vue&type=script&lang=js"
export * from "./HelpListContainer.vue?vue&type=script&lang=js"
import style0 from "./HelpListContainer.vue?vue&type=style&index=0&id=bc1a070c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1a070c",
  null
  
)

export default component.exports